import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/[locale]/blog/duree-debarras-cave-grenier/PageClient.jsx");
